var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEducation = function SvgEducation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".education_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.5H4a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h2M18 10.5l-2-2-2 2v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1Z",
    className: "education_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.5h2a1 1 0 0 1 1 1v19a1 1 0 0 1-1 1H6v-21h8",
    className: "education_svg__a"
  })));
};
export default SvgEducation;